import { Card, Typography, theme } from "antd";
import { MarkdownRenderer as BaseMarkdownRenderer } from "src/components/MarkdownRenderer";
import { TopicCard } from "../types";
import { MarkdownRecipe } from "./MarkdownRecipe";
import { parse } from "./MarkdownParser";

function MarkdownCardRenderer({ data }: { data: any }) {
  //check if data is nested or not.
  const parsedData = data.data ? data.data : data;
  return (
    <Card>
      <BaseMarkdownRenderer copyEnabled={false} downloadEnabled={false}>
        {parsedData.content}
      </BaseMarkdownRenderer>
    </Card>
  );
}

const dataStructureHelp = (
  <div>
    <p>The markdown card is used to display content in markdown format.</p>
  </div>
);

export const MarkdownCard: TopicCard = {
  id: "markdown",
  name: "Markdown Card",
  description: "Display content in markdown format",
  recipe: MarkdownRecipe,
  supportedDataTypes: ["json", "text", "markdown"],
  renderer: (data) => <MarkdownCardRenderer data={data} />,
  parser: parse,
  dataStructureHelp: dataStructureHelp,
};
